module.exports = __webpack_public_path__ + "static/media/icon_step_04.12413db6.webp";